<template>
  <div class="cards-block impact-module" :class="{ 'no-slider': !data.is_slider }">
    <div class="inner">
      <div
        v-if="data.has_border"
        class="border"
      ></div>

      <div v-if="data.title" class="title">
        <div class="title-inner">
          <h2>{{ data.title }}</h2>
        </div>
      </div>

      <gallery v-if="data.cards.length > 0 && data.is_slider">
        <div v-for="(item, index) in data.cards" class="slider-card-item" :key="index">
          <div v-if="item.image.poster" class="image">
            <div class="inner">
              <img :src="item.image.poster" :alt="item.image.alt">
            </div>
          </div>
        
          <h3>{{ item.title }}</h3>
        
          <button v-if="item.modal_text && item.modal_text !== ''" @click.prevent="setModal(index)">Learn More</button>
          <a v-else-if="item.link && item.link !== ''" :href="item.link" target="_blank">Learn More</a>
        </div>
      </gallery>

      <div v-else-if="data.cards.length >0 && !data.is_slider" class="cards">
        <div v-for="(item, index) in data.cards" class="card-item" :key="index">
          <div v-if="item.image.poster" class="image">
            <div class="inner">
              <img :src="item.image.poster" :alt="item.image.alt">
            </div>
          </div>
      
          <h3>{{ item.title }}</h3>
      
          <button v-if="item.modal_text && item.modal_text !== ''" @click.prevent="setModal(index)">Learn More</button>
          <a v-else-if="item.link && item.link !== ''" :href="item.link" target="_blank">Learn More</a>
        </div>
      </div>
    </div>

    <div class="cards-modal" :class="{ 'active': modalActive }">
      <div class="modal-closer" @click="closeModal()"></div>
      <div v-if="currentModalObject" class="modal" @click="closeModal()">
        <button class="x">✕</button>
        
        <div class="modal-content">
          <p class="title">{{ currentModalObject.title }}</p>
          
          <img :src="currentModalObject.image.poster" :alt="currentModalObject.image.alt">
          
          <div v-if="currentModalObject.modal_text" v-html="currentModalObject.modal_text" class="modal-text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery'

export default {
  name: 'CardsBlock',
  props: {
    data: Object
  },
  components: { Gallery },
  data() {
    return {
      modalActive: false,
      currentModalItem: null
    }
  },
  computed: {
    currentModalObject() {
      return this.data.cards[this.currentModalItem]
    }
  },
  methods: {
    setModal(index) {
      this.modalActive = true
      this.currentModalItem = index
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.modalActive = false
      document.body.style.overflow = 'initial'
    }
  }
}
</script>

<style scoped>
.cards-block.no-slider {
  padding: 0 2rem;
}

.cards-block.no-slider>.inner {
  /* border-top: 1px dashed white; */
  /* padding: 10rem 0; */
  /* padding: 6rem 0; */
}

.cards-block.no-slider>.inner>h2 {
  font: var(--nord-title);
  text-align: center;
  margin-bottom: 4rem;
}

.title {
  padding: 0 2rem;
}

.cards-block {
  /* padding-bottom: 10rem; */
}

.title h2 {
  font: var(--nord-title);
  text-align: center;
  margin-bottom: 4rem;
}

.slider-card-item,
.card-item {
  padding: 2rem;
  border: 1px dashed white;
  border-radius: var(--br);
  text-align: center;
}

.card-item {
  grid-column: span 1 / span 1;
}

.slider-card-item {
  width: 25%;
  margin-left: 2rem;
}

.slider-card-item:last-of-type {
  margin-right: 2rem;
}

.image {
  /* padding-bottom: 120%; */
  aspect-ratio: 5/6;
  width: 100%;
  position: relative;
  margin-bottom: 2rem;
}

.image .inner {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.image img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}

.cards {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  display: grid;
  grid-gap: 2rem;
}

.slider-card-item h3,
.card-item h3 {
  text-transform: uppercase;
  margin-bottom: .5rem;
}

.slider-card-item button,
.slider-card-item a,
.card-item button,
.card-item a {
  background: none;
  outline: none;
  border: none;
  border-radius: none;
  font: var(--serif-small);
  color: white;
  cursor: pointer;
}

.cards-modal {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5000;
  display: none;
  justify-content: center;
  align-items: center;
}

.modal {
  background: black;
  border: 1px dashed white;
  padding: 2rem 2rem 0 2rem;
  max-width: 1000px;
  width: 50%;
  height: 60%;
  border-radius: var(--br);
  position: relative;
}

.modal-closer {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.cards-modal.active {
  display: flex;
  pointer-events: auto;
}

.modal .title {
  font: var(--nord);
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 4rem;
}

.modal .x {
  position: absolute;
  top: 2rem;
  left: 2rem;
  font: var(--nord);
  background: none;
  outline: none;
  border: none;
  border-radius: none;
  color: white;
  cursor: pointer;
  z-index: 10;
}

.modal img {
  width: 40%;
  max-width: 500px;
  margin : 0 auto;
  display: block;
  margin-bottom: 4rem;
}

.modal-text {
  font: var(--serif-small);
  padding-bottom: 10rem;
}

.modal-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 0px;
}

.modal-content::-webkit-scrollbar-track {
  background-color: black;
}

.modal-content::-webkit-scrollbar {
  width: 0px;
}

@media (max-width: 1000px) {
  .card-item {
    grid-column: span 2 / span 2;
  }

  .slider-card-item {
    width: 60%;
  }

  .modal {
    max-width: none;
    width: 80%;
    height: 80%;
  }

  .modal img {
    width: 90%;
  }
}
</style>